// frontend/src/hooks/useSmoothScroll.js
import { useCallback } from 'react';
import { smoothScrollTo, scrollToElement, scrollToTop } from '../../utils/smoothScroll';

export function useSmoothScroll() {
    const scrollTo = useCallback((targetY, duration = 1500, easing = 'easeInOutCubic') => {
        smoothScrollTo(targetY, duration, easing);
    }, []);
    
    const scrollToId = useCallback((elementId, offset = 0, duration = 500) => {
        scrollToElement(elementId, offset, duration);
    }, []);
    
    const scrollUp = useCallback((duration = 0) => {
        scrollToTop(duration);
    }, []);
    
    const scrollDown = useCallback((duration = 800) => {
        const bottomPosition = document.documentElement.scrollHeight - window.innerHeight;
        smoothScrollTo(bottomPosition, duration);
    }, []);
    
    return { scrollTo, scrollToId, scrollUp, scrollDown };
}
